import {
  type BulletinNote,
  type BulletinSnapshot,
  type ObjectEvent,
  type WhiteboardSnapshot,
  type WhiteboardStroke,
} from '@veriverse/shared';
import { type createObjectEventRouter } from '../game/object-events.js';
import { useBoardStore } from '../state/board-store.js';

type Router = ReturnType<typeof createObjectEventRouter>;

/** What the whiteboard and bulletin board events do on screen (spec §6.15). */
export function registerBoardEvents(router: Router): void {
  const boards = () => useBoardStore.getState();
  const data = <T>(event: ObjectEvent) => event.data as T;

  router.on('whiteboard', 'open', (e) =>
    boards().openWhiteboard(e.objectId, data<WhiteboardSnapshot>(e)),
  );
  router.on('whiteboard', 'stroke', (e) =>
    boards().addStroke(e.objectId, data<WhiteboardStroke>(e)),
  );
  router.on('whiteboard', 'erase', (e) =>
    boards().eraseStrokes(e.objectId, data<{ ids: string[] }>(e).ids),
  );
  router.on('whiteboard', 'clear', (e) => boards().clearWhiteboard(e.objectId));
  router.on('whiteboard', 'failed', () => boards().setBoardFailed(true));

  router.on('bulletin_board', 'open', (e) =>
    boards().openBulletin(e.objectId, data<BulletinSnapshot>(e)),
  );
  router.on('bulletin_board', 'note', (e) => boards().addNote(e.objectId, data<BulletinNote>(e)));
  router.on('bulletin_board', 'unnote', (e) =>
    boards().removeNote(e.objectId, data<{ id: string }>(e).id),
  );
  router.on('bulletin_board', 'failed', () => boards().setBoardFailed(true));
}
